import { QBBeneBill } from "../components/models/QBBeneBill";
import { QBBeneficiary } from "../components/models/QBBeneficiary";
import { genericCallWithBodyAndResponseDecoded, genericGetWithParameters } from "./Networking";

export async function getAuthenticationURL(authState: string) {
  try {
    let params = {
      authState: authState
    };
    let response = await genericGetWithParameters('QuickBooks/GetAuthenticationURL', params);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function getBeneficiariesFromQuickBooksOnline(customerId: number, autToken: string, accessTokenFromSession: string) {
  try {
    let model = { CustomerId: customerId, AuthToken: autToken, AccessTokenFromSession: accessTokenFromSession }
    let method = 'POST';
    let apiName = 'QuickBooks/GetBeneficiariesFromQuickBooksOnline';
    let response = await genericCallWithBodyAndResponseDecoded(method, apiName, model);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function importQuickBooksBeneficiaries(benes: QBBeneficiary[], customerId: number, userId: string) {
  try {
    let model = {
      Beneficiaries: benes,
      CustomerId: customerId,
      UserId: userId
    }
    let method = 'POST';
    let apiName = 'QuickBooks/ImportQuickBooksBeneficiaries';
    let response = await genericCallWithBodyAndResponseDecoded(method, apiName, model);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function getVendorBillsFromQuickBooksOnline(customerId: number, autToken: string, accessTokenFromSession: string, vendorIds: string[]) {
  try {
    let model = { CustomerId: customerId, AuthToken: autToken, AccessTokenFromSession: accessTokenFromSession, VendorIds: vendorIds }
    let method = 'POST';
    let apiName = 'QuickBooks/GetVendorBillsFromQuickBooksOnline';
    let response = await genericCallWithBodyAndResponseDecoded(method, apiName, model);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function importQuickBooksVendorBills(vendorBills: QBBeneBill[], customerId: number, userId: string) {
  try {
    let model = {
      VendorBills: vendorBills,
      CustomerId: customerId,
      UserId: userId
    }
    let method = 'POST';
    let apiName = 'QuickBooks/ImportQuickBooksVendorBills';
    let response = await genericCallWithBodyAndResponseDecoded(method, apiName, model);
    return response;
  } catch (error) {
    console.error(error);
  }
}